import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ButtonProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';
import { toggleClass } from './helpers';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'bl-frontend-button',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class BlFrontendButtonComponent extends BlFrontendBaseComponent<ButtonProps> {
  @Input() text: ButtonProps['text'] = '';
  @Input() variant: ButtonProps['variant'] = 'primary';
  @Input() disabled: ButtonProps['disabled'] = false;
  @Input() type: ButtonProps['type'] = 'button';
  @Input() fullWidth: ButtonProps['fullWidth'] = false;
  @Input() leadingIcon: ButtonProps['leadingIcon'];
  @Input() trailingIcon: ButtonProps['trailingIcon'];
  @Input() density: ButtonProps['density'] = 'regular';

  @Output() onclick = new EventEmitter<MouseEvent>();

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = {
    subscribe: (fn: (event: MouseEvent) => void) => {
      if (!environment.production) {
        // eslint-disable-next-line no-console
        console.warn(
          '[DEPRECATED] The "click" output is deprecated on BlFrontendButtonComponent. Please use "onclick" instead.',
        );
      }
      return this.onclick.subscribe(fn);
    },
  } as EventEmitter<MouseEvent>;

  protected override getComponentName(): string {
    return 'Button';
  }

  protected override getProps(): ButtonProps {
    return {
      text: this.text,
      variant: this.variant,
      disabled: this.disabled,
      type: this.type,
      fullWidth: this.fullWidth,
      leadingIcon: this.leadingIcon,
      trailingIcon: this.trailingIcon,
      density: this.density,
      onclick: (event: MouseEvent) => {
        this.onclick.emit(event);
      },
    };
  }

  protected override onChanges = (changes: SimpleChanges) => {
    this.handleRefElementWidth(changes);
  };

  handleRefElementWidth(changes: SimpleChanges): void {
    if ('fullWidth' in changes) {
      const condition = changes['fullWidth'].currentValue;
      toggleClass(this.ref.nativeElement, 'w-full', condition);
    }
  }
}
